// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"Pp-z","slideIn":"Qp-z"};